export default {
  confirmed: 'Confirmado',
  canceled: 'Expirado',
  pending: 'Pendiente'
}

export const en = {
  confirmed: 'Confirmado',
  canceled: 'Expirado',
  pending: 'Pendiente'
}

export const ca = {
  confirmed: 'Confirmado',
  canceled: 'Expirado',
  pending: 'Pendiente'
}
